import { observer } from 'mobx-react-lite';
import { Airplane } from '../../../../game/airplane';
import { DATA } from '../../../../game/data';
import { AirplaneUpgradeType, AirplaneColor, AIRPLANE_UPGRADES } from '../../../../game/data/airplaneData';
import { COLORS } from '../../../../game/data/colors';
import { IMAGES } from '../../../../game/data/images';
import { UpgradeButton } from '../../Reusable/UpgradeButton';

export const AirplaneItem: React.FC<{ airplane: Airplane }> = observer(({ airplane }) => {
  const buyUpgrade = (type: AirplaneUpgradeType) => {
    const buy = () => {
      const upgradeCost = airplane.getUpgradePrice(type);
      DATA.addMoney(-upgradeCost);
      airplane.increaseUpgradeLevel(type);
    };
    if (DATA.buyMode === 'buy-1') {
      buy();
    } else if (DATA.buyMode === 'buy-max') {
      let upgradeCost = airplane.getUpgradePrice(type);
      while (upgradeCost <= DATA.money && airplane.upgrades[type] < AIRPLANE_UPGRADES[type].maxValue) {
        buy();
        upgradeCost = airplane.getUpgradePrice(type);
      }
    }
  };

  const renderColors = () => {
    const sizeRem = 1.3;
    return (Object.keys(COLORS.AIRRPLANE) as AirplaneColor[]).map((color) => {
      return (
        <div
          key={color}
          style={{
            backgroundColor: COLORS.AIRRPLANE[color],
            width: sizeRem + 'rem',
            height: sizeRem + 'rem',
            borderRadius: sizeRem / 2 + 'rem',
            cursor: 'pointer',
            marginLeft: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => {
            airplane.color = color as AirplaneColor;
          }}
        >
          {airplane.color === color && (
            <div
              style={{
                width: sizeRem / 2 + 'rem',
                borderRadius: sizeRem / 4 + 'rem',
                height: sizeRem / 2 + 'rem',
                backgroundColor: 'white',
              }}
            ></div>
          )}
        </div>
      );
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
        <img src={IMAGES.AIRPLANES[airplane.color]} alt="airplane" style={{ width: '1.3rem', marginRight: 8 }} />
        <h3>{airplane.name}</h3>
        <div style={{ flex: 1 }}></div>
        {renderColors()}
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
        {(Object.keys(AIRPLANE_UPGRADES) as AirplaneUpgradeType[]).map((upgrade) => {
          const maxLevel = airplane.upgrades[upgrade] >= AIRPLANE_UPGRADES[upgrade].maxValue;
          const hasMoney = airplane.getUpgradePrice(upgrade) <= DATA.money;
          return (
            <UpgradeButton
              key={upgrade}
              onClick={() => buyUpgrade(upgrade)}
              icon={AIRPLANE_UPGRADES[upgrade].icon}
              price={airplane.getUpgradePrice(upgrade)}
              value={AIRPLANE_UPGRADES[upgrade].readableValue(airplane.upgrades[upgrade])}
              maxLevel={maxLevel}
              hasMoney={hasMoney}
            />
          );
        })}
      </div>
    </div>
  );
});
